import PropTypes from 'prop-types'

const PermissionHeader = ({ title }) => {
    return (
        <header className='header'>
            <h1>{title}</h1>
        </header>
    )
}

PermissionHeader.defaultProps = {
    title: 'Set User Permissions',
}

PermissionHeader.propTypes = {
    title: PropTypes.string.isRequired,
}

export default PermissionHeader
